import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { MenuContainer, MenuItem } from '../../InternalDeliveryGroup/components/AdSubMenu';
import InternalDeliveryPriceListPage from './InternalDeliveryPriceList';
import PurchasePriceListPage from './PurchasePriceList';
import HomeDeliveryPriceListPage from './HomeDeliveryPriceList';
import InternalDeliveryFTPriceListPage from './InternalDeliveryFTPriceList';
import FacilityExchangePriceListPage from './FacilityExchangePriceList';
import FacilityToFacilityPriceListPage from './FacilityToFacilityPriceList';
import Input from 'components/inputs/Input';
import { usePriceListGetPriceListInfoHook } from 'api/price-list/price-list';

type PriceTab = 'truck' | 'purchase' | 'auction' | 'homedelivery' | 'internaldelivery' | 'facilityexchange' | 'facilitytofacility';

const priceListTypeToTab: Record<number, PriceTab> = {
  1: 'truck',
  2: 'purchase',
  3: 'homedelivery',
  4: 'internaldelivery',
  5: 'facilityexchange',
  6: 'facilitytofacility',
  7: 'auction',
};

const WarningText = styled.div`
  color: #c00;
  font-weight: 500;
`;

const PriceListsPage = () => {
  const [tab, setTab] = useState<PriceTab>('homedelivery');
  const [lookupId, setLookupId] = useState('');
  const [lookupVersionId, setLookupVersionId] = useState<number | null>(null);
  const [lookupWarning, setLookupWarning] = useState('');

  const fetchPriceListInfo = usePriceListGetPriceListInfoHook();

  const handleLookup = async () => {
    const id = parseInt(lookupId, 10);
    if (!(id > 0)) return;

    setLookupWarning('');
    try {
      const data = await fetchPriceListInfo({ id });

      if (!data) {
        setLookupWarning(`Kunde inte hitta prislista med id ${id}`);
        setLookupVersionId(null);
        return;
      }

      const targetTab = priceListTypeToTab[data.priceListType];
      if (targetTab) {
        setTab(targetTab);
      }
      setLookupVersionId(id);
    } catch {
      setLookupWarning(`Kunde inte hitta prislista med id ${id}`);
      setLookupVersionId(null);
    }
  };

  const clearLookup = () => {
    setLookupVersionId(null);
    setLookupWarning('');
  };

  const lookupElement: ReactNode = (
    <>
      <Input
        type="number"
        width={80}
        placeholder="Sök ID"
        value={lookupId}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setLookupId(e.target.value);
          setLookupWarning('');
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') handleLookup();
        }}
      />
      {lookupWarning && <WarningText>{lookupWarning}</WarningText>}
    </>
  );

  return (
    <>
      <MenuContainer>
        <MenuItem selected={tab === 'homedelivery'} onClick={() => { setTab('homedelivery'); clearLookup(); }}>Hemleverans & Inbyte</MenuItem>
        <MenuItem selected={tab === 'purchase'} onClick={() => { setTab('purchase'); clearLookup(); }}>Inköp</MenuItem>
        <MenuItem selected={tab === 'auction'} onClick={() => { setTab('auction'); clearLookup(); }}>Auktion</MenuItem>
        <MenuItem selected={tab === 'truck'} onClick={() => { setTab('truck'); clearLookup(); }}>Lastbil</MenuItem>
        <MenuItem selected={tab === 'internaldelivery'} onClick={() => { setTab('internaldelivery'); clearLookup(); }}>Annons</MenuItem>
        <MenuItem selected={tab === 'facilityexchange'} onClick={() => { setTab('facilityexchange'); clearLookup(); }}>Anläggningsinbyte</MenuItem>
        <MenuItem selected={tab === 'facilitytofacility'} onClick={() => { setTab('facilitytofacility'); clearLookup(); }}>Butiksleverans</MenuItem>
      </MenuContainer>
      {tab === 'truck' && <InternalDeliveryPriceListPage lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'purchase' && <PurchasePriceListPage key="purchase" lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'auction' && <PurchasePriceListPage key="auction" auction lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'homedelivery' && <HomeDeliveryPriceListPage lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'internaldelivery' && <InternalDeliveryFTPriceListPage lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'facilityexchange' && <FacilityExchangePriceListPage lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
      {tab === 'facilitytofacility' && <FacilityToFacilityPriceListPage lookupVersionId={lookupVersionId} onLookupHandled={clearLookup} lookupElement={lookupElement} />}
    </>
  );
};
export default PriceListsPage;
